import { PulseLoader } from 'react-spinners';
import Logo from '../assets/Logo';

const LoadingPage = () => (
  <div className='relative -mt-16 min-h-screen'>
    <div className='text-primary-blue absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center font-bold'>
      <Logo className='h-[100px] w-[100px]' />
      <div className='mt-3.5 flex flex-row items-baseline'>
        Loading <PulseLoader loading size={4} color='#3B82F6' />
      </div>
    </div>
  </div>
);

export default LoadingPage;
